var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5151 23.5H2.25009C1.28399 23.5 0.5 22.716 0.5 21.7499V19.7998C0.5 16.5977 3.09813 13.9996 6.30025 13.9996H6.97579C8.05632 14.4779 9.24526 14.7496 10.5004 14.7496C11.7549 14.7496 12.9483 14.4782 14.0254 13.9996H14.7006C16.2496 13.9996 17.6471 14.6223 18.6844 15.6245L15.4064 18.9025L15.0361 19.2728L14.9115 19.3974L14.8926 19.5726L14.8365 20.0912L14.8363 20.0929L14.5177 22.946L14.5176 22.947C14.4971 23.134 14.4971 23.3189 14.5151 23.5ZM23.2883 14.5581L25.9424 17.2122L19.9555 23.199L17.2749 23.4984L17.2714 23.4988C17.1229 23.5164 16.985 23.3886 17.0024 23.2244C17.0024 23.2242 17.0024 23.224 17.0025 23.2239L17.3016 20.5405L23.2883 14.5581ZM16.0006 5.99926C16.0006 9.03731 13.5385 11.4995 10.5004 11.4995C7.46236 11.4995 5.00018 9.03731 5.00018 5.99926C5.00018 2.96121 7.46236 0.499023 10.5004 0.499023C13.5385 0.499023 16.0006 2.96121 16.0006 5.99926ZM27.5428 11.1811L29.3176 12.9559C29.3179 12.9562 29.3182 12.9565 29.3185 12.9568C29.5605 13.2024 29.5605 13.5953 29.3184 13.8408C29.3182 13.8411 29.3179 13.8414 29.3176 13.8417L27.7133 15.4459L25.0552 12.7915L26.6655 11.1811C26.9062 10.9404 27.3022 10.9404 27.5428 11.1811Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit_profile.84b29e1506dd3702aef419c209624ae7.svg";
export { ForwardRef as ReactComponent };